export const SubscriptionStatus = {
    PENDING_ACTIVATION: "Pending Activation",
    ACTIVE: "Active",
    EXPIRED: "Expired",
    PENDING_RENEWAL: "Pending Renewal",
    BANNED: "Disabled"
}

export function hasActiveSubscription(status) {
    if (!status) return false;
    const isActive = status.main === 'Active' &&
        (status.sub === 'NORMAL' || status.sub === 'CANCEL');
    const isPendingRenewal = status.main === 'Pending Renewal';
    return isActive || isPendingRenewal;
}